import React from 'react';
import PageBuilder from '../../utils/helper/pagebuilder';
import CommunityAbout from '../../views/community/about';


function CommunityAboutPage(){
return(
   <div>
      <PageBuilder PageComponent={CommunityAbout} title={"Community"} />
   </div>
)
}
export default CommunityAboutPage;